define([
    "./nlgSingleListModule",
    "./nlgSingleListDirective"
], function () {
});

